import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/pages/home/index'
import AboutsUs from '@/pages/aboutUs/index'
import Contact from '@/pages/contact/index'
import Language from '@/pages/language/index'
import ProductDetail from '@/pages/product/productDetail'

Vue.use(Router)

export default new Router({
  mode:'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/aboutsUs',
      name: 'AboutsUs',
      component: AboutsUs
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/language',
      name: 'Language',
      component: Language
    },
    {
      path: '/productDetail',
      name: 'ProductDetail',
      component: ProductDetail
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js